import { Link, Outlet } from "react-router-dom";
import {
  Typography,
  Container,
  TextField,
  Switch,
  InputAdornment,
  InputLabel,
  FormControl,
  OutlinedInput,
  IconButton,
  Box,
  Toolbar,
  AppBar,
  Tabs,
  Tab,
  DialogContent,
  DialogContentText,
  Dialog,
} from "@mui/material";
import React, { useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { FiChevronRight } from "react-icons/fi";
import Loginimage from "../../assets/images/succcess.svg";
import carpark from "../../assets/images/car-parking.svg";
import tabhome from "../../assets/images/tabhome.svg";
import account from "../../assets/images/account.svg";
import support from "../../assets/images/support.svg";
import applepay from "../../assets/images/applepay.svg";
import requestcall from "../../assets/images/requestcall.svg";
import supportchat from "../../assets/images/supportchat.svg";
import { FaCalendarAlt, FaParking, FaCreditCard, FaPencilAlt, FaTrash, FaPhoneAlt } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsHouseDoor, BsClockHistory, BsPerson, BsHeadset, BsChatDots } from "react-icons/bs";
import { Button, ButtonGroup, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import HelperService from "../../Services/HelperService";

const Requestcall = () => {
  const [phone, setPhone] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    watch,
    getValues,
    register,
    clearErrors,
    reset,
  } = useForm<any>({});

  const onSubmitRequestCall = () => {
    handleOpen();
  };

  return (
    <>
      <Container>
        <div className="app-container">
          {/* Sticky Header */}
          <header className="header text-white text-center d-flex justify-content-between align-items-center">
            <Link to="/supportpage">
              <button className="back-button backbutton">
                <IoIosArrowRoundBack size={30} color="white" />
              </button>
            </Link>
            <div>Request call back</div>
            <div className=" visablityhidden">
              <button className="back-button">&nbsp;&nbsp;&nbsp;&nbsp;</button>{" "}
            </div>
          </header>
          <Container className="mt-3 px-3 pagewrap">
            <form onSubmit={handleSubmit(onSubmitRequestCall)} className="text-start">
              {/* Phone Number Input */}
              <div className="mb-3">
                <label className="form-label">Call Back Phone Number</label>
                <input
                  type="tel"
                  className="form-control"
                  placeholder="Enter Phone Number"
                  onKeyPress={HelperService.allowOnlyNumericValue}
                  {...register("phone", { required: true })}
                />
                {errors.phone && <span className="mt-4  text-danger">{"Phone is Required"}</span>}{" "}
              </div>

              {/* Date Picker */}
              <div className="mb-3">
                <label className="form-label">Date</label>
                <div className="input-group">
                  <input
                    type="date"
                    className="form-control"
                    {...register("date", { required: "Date is required" })}
                  />
                </div>
                {errors.date && <span className="mt-4  text-danger">{"Date is Required"}</span>}{" "}
              </div>

              {/* Time Picker */}
              <div className="mb-4">
                <label className="form-label">Time</label>
                <div className="input-group">
                  <input type="time" className="form-control" {...register("time", { required: "true" })} />
                </div>
                {errors.time && <span className="mt-4  text-danger">{"Time is Required"}</span>}{" "}
              </div>
              <div className="mb-3">
                <Button
                  className="btn btn-brand-1 w-100 font-bold"
                  style={{ textTransform: "none" }}
                  type="submit"
                >
                  Request Call Back
                </Button>
              </div>
            </form>
          </Container>
        </div>

        <React.Fragment>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description" className="text-center">
                <img src={Loginimage} width="78" height={78} alt="Logo" />
                <br></br>
                <h5 className="text-dark mt-3 font-bold"> Call back Request Received</h5>
                You’ll receive call from us on scheduled time
              </DialogContentText>
              <Link to="/supportpage" className="mt-3 d-block ">
                <Button autoFocus className="w-100 btn  btn-brand-1 font-bold">
                  Ok, Thank You
                </Button>
              </Link>
            </DialogContent>
          </Dialog>
        </React.Fragment>
      </Container>
    </>
  );
};

export default Requestcall;
